import { BehaviorSubject, Subject } from 'rxjs';
import { GameServices } from '../../services/game-services';
import { GameSizeMetrics } from 'src/games/common/phaser/game/scenes/scaled-base-scene';
import { BlocksTranslationsType } from '../../model/blocks-types';

export class LevelControlViewModel {
  public get levelLabelText() {
    return this.gameServices.gameTranslationService.getTranslation(BlocksTranslationsType.Level);
  }
  public get layoutConfig() {
    return this.gameServices.gameMetricsService.gameLayoutConfig;
  }
  public get blocksLogicActionBus$() {
    return this.gameServices.gameRunnerService.blocksLogicActionBus$;
  }
  public get onGameSetupStart$() {
    return this.gameServices.gameRunnerService.onGameSetupStartTrigger;
  }
  public get onResetGameScene$() {
    return this.onResetGameScene;
  }
  public get showControl$() {
    return this.showControl.asObservable();
  }

  private readonly onResetGameScene = new Subject<void>();
  private readonly showControl = new BehaviorSubject<boolean>(false);

  constructor(private gameServices: GameServices) {}

  public calculateScaleFactor(gameSizeMetrics: GameSizeMetrics): {
    scaledOffsetX: number;
    scaleFactor: number;
  } {
    return this.gameServices.gameMetricsService.calculateBoardScaling(gameSizeMetrics);
  }

  public onGameSetupStart() {
    this.showControl.next(true);
  }

  public resetGameScene() {
    this.onResetGameScene.next();
    this.showControl.next(false);
  }
}
